import { createSelector } from "reselect";

export const getMessages = createSelector(
	(state) => state.app.get("conversationlist"),
	(conversationlist) => (conversationlist ? conversationlist.slice(-3) : [])
);

export const getAllMessages = createSelector(
	(state) => state.app.get("conversationlist"),
	(conversationlist) => (conversationlist ? conversationlist : [])
);

export const getList = createSelector(
	(state) => state.app.get("messageitemlist"),
	(messageitemlist) => (messageitemlist ? messageitemlist.toJS() : [])
);

export const getCount = createSelector(
	(state) => state.app.get("count"),
	(count) => (count ? count : 1)
);

export const getConversationId = createSelector(
	(state) => state.app.get("conversationid"),
	(conversationid) => (conversationid ? conversationid : null)
);

export const getAbortController = createSelector(
	(state) => state.app.get("abortController"),
	(abortController) => (abortController ? abortController : abortController)
);

export const getConversationAllowed = createSelector(
	(state) => state.app.get("conversationAllowed"),
	(conversationAllowed) => (conversationAllowed == false ? false : true)
);

export const isResponseStopEnabledSelector = createSelector(
	(state) => state.app.get("isResponseStopEnabled"),
	(isResponseStopEnabled) => (isResponseStopEnabled == false ? false : true)
);

export const keyCategoriesListSelector = createSelector(
	(state) => state.app.get("keyCategoriesList"),
	(keyCategoriesList) => (keyCategoriesList ? keyCategoriesList.toJS() : keyCategoriesList)
);

export const getShowStreamingPlaceholderSelector = createSelector(
	(state) => state.app.get("showStreamingPlaceholder"),
	(showStreamingPlaceholder) => (showStreamingPlaceholder == false ? false : true)
);

export const getStreamingContent = createSelector(
	(state) => state.app.get("streamingContent"),
	(streamingContent) => (streamingContent ? streamingContent : null)
);

export const cosmicTicketsSelector = createSelector( 
	(state) => state.app.get("cosmicTickets"), 
	(cosmicTickets) => (cosmicTickets ? cosmicTickets.toJS() : null) 
); 

export const cosmicTicketsLoadingSelector = createSelector( 
	(state) => state.app.get("cosmicTicketsLoading"), 
	(cosmicTicketsLoading) => !!cosmicTicketsLoading 
); 

export const cosmicTicketsErrorSelector = createSelector( 
	(state) => state.app.get("cosmicTicketsError"), 
	(cosmicTicketsError) => (cosmicTicketsError ? cosmicTicketsError : null) 
); 

export const cosmicCaseActionResultSelector = createSelector( // AI
	(state) => state.app.get("cosmicCaseActionResult"), // AI
	(cosmicCaseActionResult) => (cosmicCaseActionResult ? cosmicCaseActionResult : null) // AI
); // AI

export const cosmicCaseActionLoadingSelector = createSelector( // AI
	(state) => state.app.get("cosmicCaseActionLoading"), // AI
	(cosmicCaseActionLoading) => !!cosmicCaseActionLoading // AI
); // AI